export default __webpack_public_path__ + "static/media/technologies.a4160dc8.jpg";